// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchPostSilance, fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";

import DatePicker from "react-datepicker";
import readXlsxFile from "read-excel-file";

import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import PdfPayrollReport from "../report/pdf";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../../features/master/tipe-karyawan/tipeKaryawanSlice";

const PayrollPageReport = ({}) => {
  let initialState = {
    Bulan: new Date(),
  };
  const paramsUrl = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mutation = useMutation((param) =>
    fetchGet("getKaryawanPayrollRekap", param)
  );

  const validations = [];
  const [showSave, setshowSave] = useState(false);
  const [importValue, setimportValue] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Data: [],
  });
  const [dataInsert, setdataInsert] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Data: [],
  });
  const [param, setParam] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Region: paramsUrl.id,
  });

  const [searchTipeKaryawanValue, setsearchTipeKaryawanValue] =
    React.useState("");

  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const mutationgetReport = useMutation((form) =>
    fetchPostSilance("getReport", form)
  );

  const reportData = mutationgetReport.data?.data?.Data;
  const isEmpty =
    mutationgetReport.isSuccess &&
    Object.keys(reportData || {}).length === 0;
  const errorMessage =
    mutationgetReport.error?.response?.data?.message ||
    mutationgetReport.error?.message;

  const periodeLabel = (() => {
    const bulan = parseInt(param.Bulan, 10);
    const tahun = parseInt(param.Tahun, 10);
    if (isNaN(bulan) || isNaN(tahun)) return "";
    return new Date(tahun, bulan - 1, 1).toLocaleDateString("id-ID", {
      month: "long",
      year: "numeric",
    });
  })();

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);

  useEffect(() => {
    mutationgetReport.mutate(param);
  }, [param]);

  const filterApi = () => {
    // mutationgetReport.mutate()
    setParam({
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      Region: paramsUrl.id,
      TipeKaryawan: values.tipeKaryawan,
    });
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"bulan"}
                    name={"Bulan"}
                    title={"Bulan"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4 pt-4"} style={{ paddingTop: "24px" }}>
                  <div class="w-full px-3 mb-6">
                    <select
                      value={searchTipeKaryawanValue}
                      onChange={(e) => {
                        setsearchTipeKaryawanValue(e.target.value);
                        customHandler(e.target.value, "tipeKaryawan");
                      }}
                      name="TipeKaryawanID"
                      // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      className={
                        " appearance-none w-full  text-gray-700 border border-gray-500 rounded py-2 px-3 leading-tight outline-none bg-white"
                      }
                      onClick={() => {
                        dispatch(getMinTipeKaryawan({ search: "" }));
                      }}
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {tipeKaryawan.minData.map((item, i) => (
                        <option
                          key={item.TipeKaryawanID}
                          value={item.NamaTipeKaryawan}
                        >
                          {item.NamaTipeKaryawan}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={"w-1/4"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Buka data
                  </label>

                  <button
                    type="button"
                    onClick={filterApi}
                    className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                  >
                    Buka
                  </button>
                </div>
              </div>

              <div className="flex flex-col items-center content-center ">
                {mutationgetReport.isLoading && (
                  <div className="w-full py-10 text-center text-gray-600">
                    Memuat data...
                  </div>
                )}

                {mutationgetReport.isError && (
                  <div className="w-full px-4 py-6">
                    <div className="border border-red-300 bg-red-50 text-red-700 rounded px-4 py-3">
                      <p className="font-bold">Gagal memuat data</p>
                      <p className="text-sm mt-1">{errorMessage}</p>
                    </div>
                  </div>
                )}

                {isEmpty && (
                  <div className="w-full px-4 py-6">
                    <div className="border border-yellow-300 bg-yellow-50 text-yellow-800 rounded px-4 py-3">
                      <p className="font-bold">
                        Data belum tersedia untuk periode {periodeLabel}
                      </p>
                      <p className="text-sm mt-1">
                        Rekap gaji periode ini belum pernah disimpan. Buka menu{" "}
                        <b>Rekap Payroll</b>, pilih periode yang sama, lalu
                        simpan rekapnya. Setelah itu laporan ini akan terisi.
                      </p>
                      <button
                        type="button"
                        onClick={() => navigate("/rekap-payroll")}
                        className="mt-3 text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:outline-none font-medium rounded-lg text-sm px-4 py-2"
                      >
                        Buka Rekap Payroll
                      </button>
                    </div>
                  </div>
                )}

                {mutationgetReport.isSuccess && !isEmpty && (
                  <PdfPayrollReport
                    data={mutationgetReport.data}
                    region={paramsUrl.id}
                    tipeKaryawan={values.tipeKaryawan}
                  />
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollPageReport;
